var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"questions"},[_c('Question',{attrs:{"question":_vm.questions.find(function (x) { return x.id === _vm.currentQuestion; })},on:{"confirmAnswer":_vm.confirmAnswer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }